import { render, staticRenderFns } from "./AppUserDetails.vue?vue&type=template&id=1809c4a0&"
import script from "./AppUserDetails.vue?vue&type=script&lang=js&"
export * from "./AppUserDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports